module.exports = __webpack_public_path__ + "static/img/foucs.6333087a.png";